interface Props {
    namespace: string
    filename: string
    w?: number | string
    h?: number | string
    imgProps?: React.ImgHTMLAttributes<HTMLImageElement>
}

export function Asset(props: Props) {
    const { namespace, filename, w, h, imgProps } = props

    const width = typeof w === 'number' ? `${w}px` : w
    const height = typeof h === 'number' ? `${h}px` : h

    return (
        <img 
            {...imgProps}    
            src={`/${namespace}/${filename}`} 
            width={width}
            height={height}
        />
    )
}